import{useRef as r,useEffect as t}from"react";const c=(c,e)=>{const n=r(!0);t((()=>{if(!n.current)return c();n.current=!1}),e)};export{c as useChangeEffect};
//# sourceMappingURL=useChangeEffect.js.map
